export const modalContentPadding = [0, 0, 8, 0]
export const modalContentPaddingLarge = [0, 0, 20, 0]
